/**
 * 演示模式接口（答辩/演示用：一键载入示例候选人、随时清干净）。
 *
 * 已冻结契约（backend task-10 实现，前端不改形状）：
 *   POST   /demo/load   → { loaded: number }         幂等载入演示候选人（id 前缀 demo-）
 *   DELETE /demo        → { removed: number }        只删当前用户名下的 demo- 数据
 *   GET    /demo/status → { demoCandidates: number } 当前用户有多少条演示数据
 * 三个接口都需要登录，沿用 client.ts 的 access token 与统一封套 {ok,data|error}。
 */
import { api } from './client.js';
import type { DemoLoadDto, DemoRemoveDto, DemoStatusDto } from './types.js';

export const demoApi = {
  /** 载入（幂等：重复点击不会产生重复数据） */
  load: (): Promise<DemoLoadDto> => api.post<DemoLoadDto>('/demo/load'),

  /** 清除：只删 demo- 前缀的数据，自己录入的候选人不动 */
  clear: (): Promise<DemoRemoveDto> => api.delete<DemoRemoveDto>('/demo'),

  /** 角标/设置页用：演示数据条数 */
  status: (): Promise<DemoStatusDto> => api.get<DemoStatusDto>('/demo/status'),
};